/**
 * The rule the API enforces on every *new* password — a new sub-admin, a
 * reset, a change, and an owner setting someone else's.
 *
 * Checked here as well as on the server so a form can say what is wrong before
 * the round trip. The server stays the authority: `WEAK_PASSWORD` still comes
 * back with `details.reason` if the two ever disagree.
 *
 * Not applied to the sign-in form, which accepts any 1–128 characters so that
 * passwords set under an older rule keep working.
 */
export const PASSWORD_RULE = "8–128 characters, with at least one letter and one number.";

/** Null when the password would be accepted, else a short reason why not. */
export function passwordProblem(password: string): string | null {
  if (password.length < 8) return "At least 8 characters.";
  if (password.length > 128) return "At most 128 characters.";
  if (!/[a-z]/i.test(password)) return "Include at least one letter.";
  if (!/\d/.test(password)) return "Include at least one number.";
  return null;
}
